import { fetchLandingLinks } from '@/api/landings';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { ILandingLink } from '@/entities/landing.entity';
import { hostnameFromLandingUrl } from '@/pages/landings/lib/landing-url';
import { useEffect, useState } from 'react';

const ALL_LINKS_VALUE = '__all__';

interface LandingLinkSelectProps {
	value: string;
	onChange: (linkId: string) => void;
}

function formatLinkOption(link: ILandingLink): string {
	const hostname = hostnameFromLandingUrl(link.url);
	return `${hostname} · ${link.id}`;
}

export default function LandingLinkSelect({ value, onChange }: LandingLinkSelectProps) {
	const [links, setLinks] = useState<ILandingLink[]>([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let cancelled = false;
		fetchLandingLinks({ limit: 200 })
			.then(data => {
				if (!cancelled) setLinks(data.items);
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, []);

	const selectValue = value || ALL_LINKS_VALUE;

	return (
		<div className='flex flex-col gap-1.5'>
			<Label>Ссылка</Label>
			<Select
				value={selectValue}
				onValueChange={next => onChange(next === ALL_LINKS_VALUE ? '' : next)}
				disabled={loading}
			>
				<SelectTrigger>
					<SelectValue placeholder={loading ? 'Загрузка…' : 'Все ссылки'} />
				</SelectTrigger>
				<SelectContent>
					<SelectItem value={ALL_LINKS_VALUE}>Все ссылки</SelectItem>
					{links.map(link => (
						<SelectItem key={link.id} value={link.id}>
							{formatLinkOption(link)}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
}
